"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var reconnect_js_1 = require("reconnect.js");
var AdminForm_1 = __importDefault(require("./AdminForm"));
var Resource_1 = __importDefault(require("../../Generic/Resource"));
var CodeEditorModal_1 = __importDefault(require("../../Generic/CustomWidgets/RevCodeArea/CodeEditorModal"));
var JStorage = __importStar(require("../../Actions/JStorage"));
var moment_1 = __importDefault(require("moment"));
function AdminResourcePage(props) {
  var AppActions = (0, reconnect_js_1.useOutlet)('actions')[0];
  var user = (0, reconnect_js_1.useOutlet)('user')[0];
  var _a = props.pageContext,
    resource = _a.resource,
    config = _a.config,
    _b = props.renderCustomAdminCol,
    renderCustomAdminCol = _b === void 0 ? null : _b,
    _c = props.renderCustomAdminSection,
    renderCustomAdminSection = _c === void 0 ? null : _c,
    _d = props.modifyJStorageArgs,
    modifyJStorageArgs = _d === void 0 ? {} : _d,
    _e = props.restructureDocuments,
    restructureDocuments = _e === void 0 ? null : _e,
    rjsfProps = props.rjsfProps;
  var collection = resource.collection,
    _f = resource.primaryKey,
    primaryKey = _f === void 0 ? 'id' : _f,
    _g = resource.searchField,
    searchField = _g === void 0 ? 'searchText' : _g,
    searchFields = resource.searchFields,
    _h = resource.searchApproach,
    searchApproach = _h === void 0 ? 'union' : _h,
    _j = resource.searchCaseSensitive,
    searchCaseSensitive = _j === void 0 ? 'false' : _j,
    _k = resource.disableDetailRoute,
    disableDetailRoute = _k === void 0 ? false : _k,
    predefinedQueries = resource.predefinedQueries,
    userField = resource.userField,
    path = resource.path,
    columns = resource.columns,
    formSpec = resource.formSpec,
    createFormSpec = resource.createFormSpec,
    _l = resource.actionBar,
    actionBar = _l === void 0 ? ['article', 'file'] : _l,
    onCreate = resource.onCreate,
    onGoToDetail = resource.onGoToDetail;
  var _renderCustomSection = react_1.default.useCallback(function (_a) {
    var type = _a.type,
      name = _a.name,
      context = _a.context;
    if (renderCustomAdminSection && typeof renderCustomAdminSection === 'function') {
      return renderCustomAdminSection({
        type: type,
        name: name,
        context: context
      });
    }
    // customRenderFunc backward compatibility
    if (AppActions.renderCustomAdminSection) {
      return AppActions.renderCustomAdminSection({
        type: 'resource',
        path: path,
        context: context
      });
    }
    return null;
  }, [AppActions, path, renderCustomAdminSection]);
  var modifyFetchDocumentsArgs = modifyJStorageArgs.modifyFetchDocumentsArgs,
    modifyFetchOneDocumentArgs = modifyJStorageArgs.modifyFetchOneDocumentArgs,
    modifyDeleteDocumentArgs = modifyJStorageArgs.modifyDeleteDocumentArgs,
    modifyCreateDocumentArgs = modifyJStorageArgs.modifyCreateDocumentArgs,
    modifyUpdateDocumentArgs = modifyJStorageArgs.modifyUpdateDocumentArgs;
  function fetchRecords(_a) {
    var _b = _a === void 0 ? {} : _a,
      sort = _b.sort,
      keyword = _b.keyword,
      paging = _b.paging,
      extraQueries = _b.extraQueries,
      filter = _b.filter;
    return __awaiter(this, void 0, void 0, function () {
      var resp, query, filterQuery, _i, predefinedQueries_1, q, searchArr, _c, searchFields_1, field, args, _jsStorageResults, err_1;
      var _d, _e;
      return __generator(this, function (_f) {
        switch (_f.label) {
          case 0:
            return [4 /*yield*/, AppActions.fetchCustomResources(resource, {
              sort: sort,
              keyword: keyword,
              filter: filter,
              paging: paging,
              extraQueries: extraQueries
            })];
          case 1:
            resp = _f.sent();
            if (!(resp === null)) return [3 /*break*/, 7];
            query = {};
            filterQuery = {};
            if (Array.isArray(predefinedQueries)) {
              for (_i = 0, predefinedQueries_1 = predefinedQueries; _i < predefinedQueries_1.length; _i++) {
                q = predefinedQueries_1[_i];
                Object.assign(query, q);
              }
            }
            if (userField) {
              query[userField] = user.sub;
            }
            if (keyword) {
              if (Array.isArray(searchFields)) {
                searchArr = [];
                for (_c = 0, searchFields_1 = searchFields; _c < searchFields_1.length; _c++) {
                  field = searchFields_1[_c];
                  if (searchCaseSensitive) {
                    searchArr.push((_d = {}, _d[field] = {
                      $regex: "".concat(keyword)
                    }, _d));
                  } else {
                    searchArr.push((_e = {}, _e[field] = {
                      $regex: "".concat(keyword),
                      $options: 'i'
                    }, _e));
                  }
                }
                if (searchApproach === 'intersection') {
                  query['$and'] = searchArr;
                } else {
                  query['$or'] = searchArr;
                }
              } else if (searchField) {
                query[searchField] = {
                  $regex: "".concat(keyword)
                };
              }
            }
            if (filter) {
              filterQuery = __assign({}, filter);
            }
            args = [collection, __assign(__assign(__assign({}, query), filterQuery), extraQueries), sort ? [sort] : [], paging];
            if (modifyFetchDocumentsArgs) {
              args = modifyFetchDocumentsArgs.apply(void 0, args);
            }
            return [4 /*yield*/, JStorage.fetchDocuments.apply(JStorage, args)];
          case 2:
            _jsStorageResults = _f.sent();
            if (!(typeof restructureDocuments === 'function')) return [3 /*break*/, 6];
            _f.label = 3;
          case 3:
            _f.trys.push([3, 5,, 6]);
            return [4 /*yield*/, restructureDocuments(collection, _jsStorageResults)];
          case 4:
            _jsStorageResults = _f.sent();
            return [3 /*break*/, 6];
          case 5:
            err_1 = _f.sent();
            return [3 /*break*/, 6];
          case 6:
            return [2 /*return*/, _jsStorageResults];
          case 7:
            return [2 /*return*/, resp];
        }
      });
    });
  }
  function deleteRecordById(id) {
    var _a;
    var args = [collection, (_a = {}, _a[primaryKey] = id, _a)];
    if (modifyDeleteDocumentArgs) {
      args = modifyDeleteDocumentArgs.apply(void 0, args);
    }
    return JStorage.deleteDocument.apply(JStorage, args);
  }
  function fetchRecordById(id) {
    var _a;
    var args = [collection, (_a = {}, _a[primaryKey] = id, _a)];
    if (modifyFetchOneDocumentArgs) {
      args = modifyFetchOneDocumentArgs.apply(void 0, args);
    }
    return JStorage.fetchOneDocument.apply(JStorage, args);
  }
  var genericResourceColumns = columns.map(function (col) {
    if (col.dataType === 'boolean') {
      col.render = function (_, record) {
        return react_1.default.createElement("div", null, record[col.dataIndex] ? '是' : '否');
      };
      col.render = function (_, record) {
        return react_1.default.createElement("div", null, record[col.dataIndex] ? '是' : '否');
      };
    } else if (col.dataType === 'timestamp') {
      col.render = function (_, record) {
        return react_1.default.createElement("div", null, (0, moment_1.default)(new Date(record[col.dataIndex])).format('YYYY-MM-DD'));
      };
    } else if (col.customType) {
      col.render = function (_, record) {
        if (renderCustomAdminCol && typeof renderCustomAdminCol === 'function') {
          return renderCustomAdminCol({
            col: col,
            record: record
          });
        }
        // customRenderFunc backward compatibility
        if (AppActions.renderCustomAdminCol) {
          return AppActions.renderCustomAdminCol({
            col: col,
            record: record
          });
        }
        return null;
      };
    }
    return col;
  });
  var genericResourceActions = {
    setLoading: AppActions.setLoading,
    fetchRecords: fetchRecords,
    fetchRecordById: fetchRecordById,
    deleteRecordById: deleteRecordById
  };
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Resource_1.default, {
    location: props.location,
    collection: collection,
    spec: {
      path: path,
      primaryKey: primaryKey,
      name: resource.name,
      backPath: resource.backPath,
      backTitle: resource.backTitle,
      columns: genericResourceColumns,
      actions: genericResourceActions,
      disableDetailRoute: disableDetailRoute
    },
    onGoToDetail: resource.onGoToDetail,
    onCreate: resource.onCreate,
    querySpec: resource.querySpec,
    canBulkWrite: resource.canBulkWrite,
    bulkWriteFormSpec: resource.bulkWriteFormSpec,
    resourceTableProps: resource.resourceTableProps,
    renderCreateButton: resource.renderCreateButton,
    renderDeleteButton: resource.renderDeleteButton,
    renderDetailButton: resource.renderDetailButton,
    renderHeader: resource.renderHeader,
    renderCustomSection: function (props) {
      return _renderCustomSection({
        type: 'resource',
        name: 'generic-resource',
        context: props
      });
    },
    renderDetail: function (props) {
      if (props.instance) {
        return react_1.default.createElement(AdminForm_1.default, __assign({}, props, {
          renderCustomSection: renderCustomAdminSection ? _renderCustomSection : null,
          modifyJStorageArgs: {
            modifyCreateDocumentArgs: modifyCreateDocumentArgs,
            modifyUpdateDocumentArgs: modifyUpdateDocumentArgs
          },
          primaryKey: primaryKey,
          collection: collection,
          actionBar: actionBar,
          formSpec: formSpec,
          config: config,
          path: path,
          rjsfProps: rjsfProps
        }));
      } else {
        return react_1.default.createElement(AdminForm_1.default, __assign({}, props, {
          renderCustomSection: renderCustomAdminSection ? _renderCustomSection : null,
          modifyJStorageArgs: {
            modifyCreateDocumentArgs: modifyCreateDocumentArgs,
            modifyUpdateDocumentArgs: modifyUpdateDocumentArgs
          },
          primaryKey: primaryKey,
          collection: collection,
          actionBar: actionBar,
          formSpec: createFormSpec || formSpec,
          config: config,
          path: path,
          rjsfProps: rjsfProps
        }));
      }
    }
  }), react_1.default.createElement(CodeEditorModal_1.default, null));
}
exports.default = AdminResourcePage;